export const ARCHIVO_ADJUNTO_TIPO = {
  BOLETA: 'BOLETA',
  INGRESO: 'INGRESO',
  EVIDENCIA: 'EVIDENCIA',
  OTROS: 'OTROS',
  GUIA_DESPACHO: 'GUIA',
  CONSENTIMIENTO: 'CONSENT',
}
